import { Button } from "@/components/ui/button";
import { ExternalLink, Sparkles, FileText, Target, TrendingUp, MapPin, Star, Link2, Image as ImageIcon, Zap } from "lucide-react";
import { Link } from "react-router-dom";

const tips = [
  {
    icon: Sparkles,
    title: "Publikuj 2-4 artykuły blogowe miesięcznie",
    desc: "Google nagradza świeży content. Użyj generatora AI by tworzyć artykuły wokół fraz: 'naklejki 3D', 'naklejki żywiczne', 'naklejki wypukłe', 'doming', 'etykiety 3D'.",
    cta: { label: "Otwórz generator AI", to: "/ai-generator" },
  },
  {
    icon: Target,
    title: "Long-tail keywords (frazy z długim ogonem)",
    desc: "Twórz treści pod konkretne zapytania: 'naklejki 3D na samochód cena', 'naklejki żywiczne na kask motocyklowy', 'doming logo firmy'. Mniejsza konkurencja = łatwiejsze 1. miejsce.",
  },
  {
    icon: MapPin,
    title: "SEO lokalne - Google Moja Firma",
    desc: "Załóż / zoptymalizuj wizytówkę Google Business Profile. Dodaj zdjęcia produktów co tydzień, zbieraj opinie 5★, odpowiadaj na recenzje. Lokalne 'mapa pack' przebija konkurencję organiczną.",
  },
  {
    icon: Star,
    title: "Zbieraj opinie Google + na stronie",
    desc: "Po każdym zamówieniu wyślij prośbę o opinię (do maila po wysyłce). Dodaj sekcję opinii z gwiazdkami i schema.org Review na stronie głównej - rich snippets w wynikach Google.",
  },
  {
    icon: Link2,
    title: "Backlinki branżowe",
    desc: "Pozyskaj linki z: katalogów firm (Panorama Firm, PKT.pl, ALEO), portali branżowych (Print&Publishing, Signs.pl), blogów motoryzacyjnych i tuningowych. 1 jakościowy link > 50 śmieciowych.",
  },
  {
    icon: ImageIcon,
    title: "Optymalizacja zdjęć produktów",
    desc: "Każde zdjęcie: nazwa pliku 'naklejki-3d-zywiczne-czarne.jpg', alt opisowy z frazą, format WEBP, lazy loading. Google Images to 20% ruchu - wykorzystaj go.",
  },
  {
    icon: Zap,
    title: "Core Web Vitals - prędkość",
    desc: "Sprawdź PageSpeed Insights. Cel: LCP <2.5s, CLS <0.1, INP <200ms. Wolna strona = niższe pozycje. Włącz cache, kompresuj wideo, używaj CDN.",
  },
  {
    icon: FileText,
    title: "Strony porównawcze i poradniki",
    desc: "Stwórz: 'Naklejki 3D vs druk UV', 'Jak wybrać naklejkę żywiczną', 'Naklejki 3D - kompletny poradnik 2026'. Długie, eksperckie treści (>2000 słów) dominują w SERP.",
  },
  {
    icon: TrendingUp,
    title: "Internal linking",
    desc: "Z każdego artykułu blogowego linkuj do: kalkulatora, strony produktów, kontaktu. Anchor text z frazą kluczową ('zamów naklejki 3D online'). Buduje autorytet podstron.",
  },
];

export default function SeoTips() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-foreground">SEO - Wyprzedź konkurencję</h2>
          <p className="text-muted-foreground text-sm">Konkretne działania, które dadzą Ci wyższe pozycje w Google.</p>
        </div>
        <Link to="/seo-audit" target="_blank">
          <Button variant="outline" className="gap-2">
            <ExternalLink className="w-4 h-4" />
            Audyt SEO strony
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {tips.map((tip, i) => {
          const Icon = tip.icon;
          return (
            <div key={i} className="bg-card border border-border rounded-xl p-5 space-y-3 hover:border-accent/50 transition-colors">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-accent/15 flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-accent" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-foreground">{tip.title}</h3>
                </div>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">{tip.desc}</p>
              {tip.cta && (
                <Link to={tip.cta.to}>
                  <Button size="sm" variant="secondary" className="gap-2">
                    <Sparkles className="w-3.5 h-3.5" />
                    {tip.cta.label}
                  </Button>
                </Link>
              )}
            </div>
          );
        })}
      </div>

      <div className="bg-primary/5 border border-primary/20 rounded-xl p-5 space-y-2">
        <h3 className="font-semibold text-foreground flex items-center gap-2">
          <TrendingUp className="w-4 h-4 text-primary" />
          Plan na pierwsze 30 dni
        </h3>
        <ol className="text-sm text-muted-foreground space-y-1 list-decimal list-inside">
          <li>Zoptymalizuj Google Moja Firma - zdjęcia, opis z frazami, godziny.</li>
          <li>Opublikuj 4 artykuły blogowe (co tydzień jeden) - użyj generatora AI.</li>
          <li>Poproś 10 ostatnich klientów o opinię w Google.</li>
          <li>Zarejestruj firmę w 5 katalogach (Panorama, PKT, ALEO, Oferteo, Allegro Lokalnie).</li>
          <li>Dodaj alty i opisowe nazwy do wszystkich zdjęć w galerii.</li>
          <li>Sprawdź PageSpeed - jeśli LCP {`>`} 2.5s zoptymalizuj wideo i grafiki.</li>
        </ol>
      </div>
    </div>
  );
}
